import { IClient } from 'src/utils/Interfaces/client.interface'
import { ClientDataTabs } from '../ClientDataTabs'
import style from './style.module.scss'
import { EditClientMainInfo } from '../EditClientMainInfo'
import { EditClientAdditionalInfo } from '../EditClientAdditionalInfo'
import { EditClientAssets } from '../EditClientAssets'

export const ClientInfo = ({ data }: { data: IClient }) => {
  return (
    <div className="block">
      <div className={style.client_info}>
        <div className={style.main_info}>
          <EditClientMainInfo data={data} />
          <div className={style.logo}>
            <img src={data?.logo} alt="logo" />
          </div>
          <div className={style.name}>
            <span>Name:</span> {data?.name}
          </div>
          <div>
            <span>Site:</span>
            <a href={data?.siteUrl}>{data?.siteUrl}</a>
          </div>
          <div className={style.status}>
            <span>Status:</span> {data?.status}
          </div>

          <div>
            <span>Type: </span>
            {data?.type}
          </div>
        </div>
        <div className={style.additional_info}>
          <div className={style.info}>
            <EditClientAdditionalInfo data={data} />
            <span>Info:</span>
            {data?.baseInfo}
          </div>

          <div className={style.assets}>
            <EditClientAssets data={data} />
            <span>Assets:</span>
            {data?.assets}
          </div>
        </div>
      </div>
      <ClientDataTabs data={data} />
    </div>
  )
}
